import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import DataService from "../../../../config/DataService";
import { Api } from "../../../../config/Api";
import moment from "moment";
import { toast } from "react-toastify";

// for tabal data

const SellerList = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editRowsData, setEditRowsData] = useState({});
  const [viewRowsData, setViewRowsData] = useState({});

  // Add New Seller
  const [openAddNewSellerModal, setAddNewSellerModal] = React.useState(false);
  const handleOpenAddNewSellerModal = () => setAddNewSellerModal(true);
  const handleCloseAddNewSellerModal = () => setAddNewSellerModal(false);

  // Edit Seller
  const [openEditSellerModal, setEditSellerModal] = React.useState(false);
  const handleOpenEditSellerModal = () => setEditSellerModal(true);
  const handleCloseEditSellerModal = () => setEditSellerModal(false);

  // view Seller
  const [openViewSellerModal, setViewSellerModal] = React.useState(false);
  const handleOpenViewSellerModal = () => setViewSellerModal(true);
  const handleCloseViewSellerModal = () => setViewSellerModal(false);

  // pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleView = (row) => {
    setViewRowsData(row);
    handleOpenViewSellerModal();
  };

  const handleStatus = async (row) => {
    const data = {
      id: row?._id,
      status: !row?.isActive,
    };
    await DataService.post(Api.Admin.ACTIVE_DEACTIVE_SELLER_BUYER, data)
      .then((res) => {
        toast.success(res?.data?.message);
        getSellerList();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSellerList = async () => {
    setIsLoading(true);
    await DataService.get(Api.Admin.GET_ALL_SELLER)
      .then((res) => {
        setRows(res?.data?.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleApprove = async (row) => {
    if (row?.status === "Approved") {
      toast.warning("Seller already approved");
    } else {
      const data = {
        id: row?._id,
        status: "Approved",
      };
      await DataService.post(Api.Admin.APPROVE_REJECT_SELLER, data)
        .then((res) => {
          toast.success(res?.data?.message);
          getSellerList();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const handleReject = async (row) => {
    if (row?.status === "Rejected") {
      toast.warning("Seller already rejected");
    } else {
      const data = {
        id: row?._id,
        status: "Rejected",
      };
      await DataService.post(Api.Admin.APPROVE_REJECT_SELLER, data)
        .then((res) => {
          toast.success(res?.data?.message);
          getSellerList();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const handleEdit = (row) => {
    setEditRowsData(row);
    handleOpenEditSellerModal();
  };
  useEffect(() => {
    getSellerList();
  }, []);

  if (isLoading) {
    return <PagesIndex.Loader />;
  } else {
    return (
      <>
        <Index.Box className="flex-all admin-title-box">
          <Index.Box className="admin-sub-title-main">
            <Index.Typography
              className="admin-sub-title admin-buyer-title"
              component="h3"
              variant="h3"
            >
              Seller List
            </Index.Typography>
          </Index.Box>
          <Index.Box className="view-btn-main border-btn-main">
            <PagesIndex.BlueFillButton
              className="view-order-btn blue-fill-btn"
              btnLabel="Add New"
              onClick={handleOpenAddNewSellerModal}
            />
          </Index.Box>
        </Index.Box>

        <Index.Box className="page-buyer-table-main">
          <Index.TableContainer
            component={Index.Paper}
            className="table-container cus-scrollbar"
          >
            <Index.Table
              sx={{ minWidth: 1010 }}
              aria-label="simple table"
              className="table"
            >
              <Index.TableHead className="table-head">
                <Index.TableRow className="table-row">
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    style={{ fontWeight: 700 }}
                    width="15%"
                  >
                    Name
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    style={{ fontWeight: 700 }}
                    width="24%"
                  >
                    Email
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    style={{ fontWeight: 700 }}
                    width="14%"
                  >
                    Phone Number
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    style={{ fontWeight: 700 }}
                    width="12%"
                  >
                    Date
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    style={{ fontWeight: 700 }}
                    width="10%"
                  >
                    Status
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    align="center"
                    style={{ fontWeight: 700 }}
                    width="25%"
                  >
                    Action
                  </Index.TableCell>
                </Index.TableRow>
              </Index.TableHead>
              <Index.TableBody className="table-body">
                {rows?.length > 0 ? (
                  rows
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((row) => (
                      <Index.TableRow
                        key={row._id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <Index.TableCell
                          component="td"
                          variant="td"
                          scope="row"
                          className="table-td"
                        >
                          {row.fullName ? row.fullName : "-"}
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          {row.email ? row.email : "-"}
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          {row.phoneNumber ? row.phoneNumber : 0}
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          {row?.createdAt
                            ? moment(row?.createdAt).format(
                                "DD-MM-YYYY HH:mm:ss"
                              )
                            : "-"}
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Box
                            sx={{
                              color: "white",
                              backgroundColor:
                                row?.status === "Rejected"
                                  ? "red"
                                  : row?.status === "Pending"
                                  ? "orange"
                                  : "green",
                            }}
                            className="buyer-list-status"
                          >
                            {row?.status ? row.status : "-"}
                          </Index.Box>
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                          align="center"
                        >
                          <Index.Box sx={{ padding: "0px", margin: "0px" }}>
                            <Index.IconButton
                              onClick={() => {
                                handleApprove(row);
                              }}
                            >
                              <Index.CheckIcon style={{ color: "green" }} />
                            </Index.IconButton>

                            <Index.IconButton
                              onClick={() => {
                                handleReject(row);
                              }}
                            >
                              <Index.ClearIcon style={{ color: "red" }} />
                            </Index.IconButton>

                            <Index.IconButton
                              onClick={() => {
                                handleEdit(row);
                              }}
                            >
                              <img
                                src={PagesIndex.Svg.editingIcon}
                                alt="edit icon"
                                width="20"
                                height="20"
                              />
                            </Index.IconButton>

                            <Index.IconButton
                              onClick={() => {
                                handleView(row);
                              }}
                            >
                              <Index.Visibility style={{ color: "black" }} />
                            </Index.IconButton>

                            <Index.IconButton
                              sx={{ width: "40px" }}
                              className="toggle-btn"
                              disableRipple
                            >
                              <Index.Switch
                                checked={row?.isActive && row?.isActive}
                                onClick={(e) => {
                                  handleStatus(row);
                                }}
                              />
                            </Index.IconButton>
                          </Index.Box>
                        </Index.TableCell>
                      </Index.TableRow>
                    ))
                ) : (
                  <Index.TableRow>
                    <Index.TableCell
                      component="td"
                      variant="td"
                      scope="row"
                      className="table-td"
                      colSpan={6}
                    >
                      No Record found
                    </Index.TableCell>
                  </Index.TableRow>
                )}
              </Index.TableBody>
            </Index.Table>
          </Index.TableContainer>
          {rows?.length > 0 ? (
            <>
              <Index.TablePagination
                className="cus-scrollbar"
                component="div"
                page={page}
                count={rows?.length}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[10, 15, 20]}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          ) : (
            ""
          )}
        </Index.Box>

        <PagesIndex.AddNewSeller
          openAddNewSellerModal={openAddNewSellerModal}
          getSellerList={getSellerList}
          handleCloseAddNewSellerModal={handleCloseAddNewSellerModal}
        />
        <PagesIndex.EditSeller
          openEditSellerModal={openEditSellerModal}
          rows={editRowsData}
          getSellerList={getSellerList}
          handleCloseEditSellerModal={handleCloseEditSellerModal}
        />
        <PagesIndex.ViewSeller
          openViewSellerModal={openViewSellerModal}
          rows={viewRowsData}
          handleCloseViewSellerModal={handleCloseViewSellerModal}
        />
      </>
    );
  }
};

export default SellerList;
